import classNames from "classnames";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";
import React from "react";
import Button from "../button/button.jsx";
import "./login.css";

const SubmitLoginButton = ({ className, onClick, disabled, ...props }) => (
    <div className={`${className}`}>
        <Button
            className={
                disabled
                    ? "btnSubmit submitLoginButtonDisabled"
                    : "btnSubmit submitLoginButton"
            }
            onClick={disabled ? null : onClick}
        >
            <React.Fragment>
                {/* 立即注册 */}
                {/* {props.tabIndex == 1 ? (
                    <FormattedMessage
                        defaultMessage="Register"
                        description="Label for sign up"
                        id="gui.account.signUpLong"
                    />
                ) : null} */}
                {/* 登录 */}
                {disabled}
                {props.loginType == 'login' ? (
                    // <span>登录</span>
                    <FormattedMessage
                        defaultMessage="Login"
                        description="Label for submit login"
                        id="general.signIn"
                    />
                ) : null}
                {props.loginType == 'register' ? (
                    // <span>注册</span>
                    <FormattedMessage
                        defaultMessage="Register"
                        description="Label for sign up"
                        id="gui.homePage.registerBtn"
                    />
                ) : null}
                {props.tabIndex == 2 ? (
                    // <span>
                    //     重置密码
                    // </span>
                    <FormattedMessage
                        defaultMessage="Reset Password"
                        description="Label for reset password"
                        id="general.resetPassword"
                    />
                ) : null}
            </React.Fragment>
        </Button>
    </div>
);
SubmitLoginButton.propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func,
    tabIndex: PropTypes.number,
    disabled: PropTypes.bool,
    loginType: PropTypes.string,
};
SubmitLoginButton.defaultProps = {
    onClick: () => {},
};
export default SubmitLoginButton;
